
// Language data and utilities for the language switcher

// Map of language codes to flag emojis and display names
export const languageInfo = {
  de: { flag: '🇩🇪', name: 'Deutsch' },
  en: { flag: '🇬🇧', name: 'English' },
  fr: { flag: '🇫🇷', name: 'Français' },
  it: { flag: '🇮🇹', name: 'Italiano' }
};

// Language code type for type safety
export type LanguageCode = keyof typeof languageInfo;

// Utility function to check if a string is a valid language code
export const isValidLanguageCode = (code: string): code is LanguageCode => {
  return Object.keys(languageInfo).includes(code);
};
